import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { provideNgxMask } from 'ngx-mask';
import { generateId } from '@lc/util';
import { SafeHtml } from '@angular/platform-browser';
import { BspkFormField } from '../form-field';
import { provideValidator, provideValueAccessor, TextInputControlValueAccessor } from '../util';
import { BspkTextInput } from '../text-input';

@Component({
  selector: 'bspk-text-field',
  imports: [BspkFormField, BspkTextInput],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.scss',
  providers: [
    provideValidator(BspkTextField),
    provideValueAccessor(BspkTextField),
    ...provideNgxMask(),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-bspk': 'text-field',
  },
})
export class BspkTextField extends TextInputControlValueAccessor {
  readonly errorMessage = input<string | SafeHtml>();
  readonly helperText = input<string>();
  readonly controlId = input(generateId('text-field'));
}
